import { render } from "./ExpenseModal.vue?vue&type=template&id=2743dbac"
import script from "./ExpenseModal.vue?vue&type=script&lang=js"
export * from "./ExpenseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__